import React, { useCallback, useEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";
import FormLabel from "../../../components/core/typography/FormLabel";
import TextArea from "../../../components/core/form-components/TextArea";
import RadioButton from "../../../components/core/form-components/RadioButton";
import UploadFile from "../../../assets/images/icon_image_upload.svg";
import Button from "../../../components/core/form-components/Button";
import Paragraph from "../../../components/core/typography/Paragraph";
import SwitchToggle from "../../../components/core/form-components/SwitchToggle";
import InputType from "../../../components/core/form-components/InputType";
import SelectType from "../../../components/core/form-components/SelectType";
import Modal from "../../../components/core/Modal";
import UploadFileModal from "./UploadFileModal";
import GuideModal from "./GuideModal";
import ColorWheel from "../../../assets/images/icon_color_wheel.svg";
import ColorPickerModal from "./ColorPickerModal";
import { useDispatch, useSelector } from "react-redux";
import { languageIdSelector } from "../../../redux/slices/website/languageSlice";
import { LanguageTranslation } from "../../../components/language-translation/LanguageTranslation";
import DummyImg from "../../../assets/images/art2.png";
import { IoClose } from "react-icons/io5";
import { useNavigate, useParams } from "react-router-dom";
import { hideLoader, showLoader } from "../../../redux/slices/siteLoaderSlice";
import {
  getArtDetails,
  getArtTags,
} from "../../../services/website/feedService";
import { commonListSelector } from "../../../redux/slices/website/commonSlice";
import {
  createArtroomPost,
  createArtroomPostVideo,
  createPost,
  createPostText,
  createPostVideo,
  editArt,
} from "../../../services/website/piecesService";
import { pathRoute } from "../../../routes/PathRoute";
import { userSelector } from "../../../redux/slices/userSlice";
import { string } from "yup";
import { ProductStatus } from "../../../constant/constant";
import { IoMdPlay } from "react-icons/io";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Video from "yet-another-react-lightbox/plugins/video";
import { postValidationSchema } from "../../../validations/website/createPostValidationSchema";
import { debounce } from "lodash";
import VideoPreview from "./VideoPreview";
import { ToastShow } from "../../../redux/slices/toastSlice";
import Swal from "sweetalert2";

interface colorInterface {
  id: number;
  hexcode: string;
  name: string;
}
interface FormValues {
  profileImage?: string;
  description?: string;
  title: string;
  width: string | number;
  height: string | number;
  depth: string | number;
  weight: string | number;
  price: string | number;
  quantity: string | number;
  category: string;
  artTag: {
    id: number;
    name: string;
  };
  mainColor: {
    hexcode: string;
    id: number;
    name: string;
  };
  secondaryColor: {
    hexcode: string;
    id: number;
    name: string;
  };
  status?: string;
  framed?: boolean;
  categoryId?: string | number;
  type: string | number; // Remove the optional '?'
  publicationDate?: string;
  video?: any;
  creationYear?: string;
  selectedColors?: colorInterface[];
}

interface Photo {
  file: File; // Specify File type for the file
  photos: string; // URL string for the photo preview
}
interface Option {
  value: string | number;
  label: string;
}
function CreatePost() {
  const language = useSelector(languageIdSelector);
  const langId = language?.languageId ?? "fr";
  const [modalOpen, setModalOpen] = useState(false);
  const [guideModal, setGuideModal] = useState(false);
  const [colorPickerModal, setColorPickerModal] = useState(false);
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [type, setType] = useState();
  const allData = useSelector(commonListSelector);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const webProfileData = useSelector(userSelector);
  const [photoUrl, setPhotoUrl] = useState<Photo[]>([]);
  // const [allImage, setAllImages] = useState<Photo[]>([]);
  const [isFramed, setIsFramed] = useState(false);
  const [isMedia, setIsMedia] = useState(0);
  const [isFileType, setIsFileType] = useState("");
  const [artOptions, setArtOptions] = useState<Option[]>([]);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState<string | undefined>(undefined);
  const [isFeed, setIsFeed] = useState(0);
  const [hasMore, setHasMore] = useState(true); // Track if there are more items to load
  const [loading, setLoading] = useState(false); // Track loading state
  const pageRef = useRef(1);
  const formikRef = useRef<any>(null); // Ref to access Formik methods
  const postValidationSchemaLang = postValidationSchema(langId);
  // 1. Update state initialization (remove photoUrl)
  const [allImage, setAllImages] = useState<Photo[]>([]);
  const [defaultInitialValues, setDefaultInitialValues] = useState<FormValues>({
    profileImage: "",
    description: "",
    title: "",
    width: "",
    height: "",
    depth: "",
    weight: "",
    price: "",
    quantity: "",
    category: "",
    artTag: {
      id: 0,
      name: "",
    },
    mainColor: {
      id: 0,
      name: "",
      hexcode: "",
    },
    secondaryColor: {
      id: 0,
      name: "",
      hexcode: "",
    },
    status: "",
    framed: false,
    categoryId: "",
    type: 0,
    publicationDate: "",
    video: "",
    creationYear: "",
    selectedColors: [],
  });

  const categoryOptions = allData?.categories.map(
    (category: { id: string; name: string }) => ({
      label: category.name, // The label displayed in the dropdown
      value: category.id, // The value to be sent when an option is selected
    })
  );

  const colorOptions = allData;
  // Use `useRef` instead of `useState` for page tracking
  useEffect(() => {
    if (search) {
      setArtOptions([]); // Clear previous data
      setHasMore(true); // Reset hasMore when search changes
      pageRef.current = 1; // Reset page to the first page
      getArtTagsFunc(1); // Fetch first page of data
    } else {
      setArtOptions([]); // Clear data if no search term
    }
  }, [search]);

  const getArtTagsFunc = async (page: number) => {
    if (loading) return; // Prevent duplicate calls while loading

    setLoading(true);
    let queryString = `?criteria=${search}&page=${page}`;

    try {
      const response = await getArtTags(queryString);
      if (response?.data?.code === 200) {
        // ✅ Stop pagination if no tags are returned
        if (!response.data.tags.length) {
          setHasMore(false);
          setLoading(false);
          return;
        }
        const formattedData = response.data.tags.map((category: any) => ({
          label: category.name,
          value: category.id,
        }));

        setArtOptions((prevOptions) =>
          page === 1 ? formattedData : [...prevOptions, ...formattedData]
        );

        setHasMore(response.data.next > 0);

        // Only update pageRef if the response is for the latest page request
        if (page === pageRef.current) {
          pageRef.current++;
        }
      }
    } catch (error) {
      console.error("Error fetching art tags:", error);
    } finally {
      setLoading(false);
    }
  };

  const getNextPage = () => {
    if (!loading && hasMore) {
      getArtTagsFunc(pageRef.current);
    }
  };

  // In CreatePost.tsx
  const fetchArtDetails = async () => {
    dispatch(showLoader());

    try {
      const response = await getArtDetails(id);
      setType(response?.data?.art?.type);
      let profileData = response?.data?.art;

      // Initialize selectedColors array with main and secondary colors
      const initialColors = [];
      if (profileData.mainColor) initialColors.push(profileData.mainColor);
      if (profileData.secondaryColor)
        initialColors.push(profileData.secondaryColor);

      let data = {
        profileImage:
          profileData?.images?.length > 0 && profileData?.images[0]?.imageUrl
            ? profileData.images[0].imageUrl
            : undefined,
        title: profileData.title || "",
        description: profileData.description || "",
        width: profileData.width || 0,
        height: profileData.height || 0,
        depth: profileData.depth || 0,
        weight: profileData.weight || 0,
        price: profileData.price || 0,
        quantity: profileData.quantity || 0,
        category: profileData.category.name || "",
        artTag: profileData.Tags?.[0] || { id: 0, name: "" },
        mainColor: profileData.mainColor || { id: 0, name: "", hexcode: "" },
        secondaryColor: profileData.secondaryColor || {
          id: 0,
          name: "",
          hexcode: "",
        },
        status: profileData.status || "",
        framed: profileData?.framed || false,
        categoryId: 0,
        // type: profileData?.mediaType || 0,
        type: 1 || 0,
        publicationDate: profileData?.publicationDate || "",
        video: profileData?.video?.videoUrl || "",
        creationYear: profileData?.creationYear,
        selectedColors: initialColors, // Initialize with actual colors
      };
      setDefaultInitialValues({ ...data });
    } catch (error) {
      console.error("Error fetching feed:", error);
    } finally {
      dispatch(hideLoader());
    }
  };

  useEffect(() => {
    if (id) {
      fetchArtDetails();
    }
  }, [id]);

  const openLightbox = (videoUrl: string) => {
    setVideoUrl(videoUrl);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setVideoUrl(undefined);
  };

  const handleEdit = async (values: FormValues) => {
    const params = {
      height: values?.height,
      width: values?.width,
      weight: values?.weight,
      depth: values?.depth,
      price: values?.price,
      description: values?.description,
      title: values?.title,
      quantity: values?.quantity,
      creationYear: values?.creationYear,
      status: values?.status,
      framed: values?.framed,
      type: values?.video ? 0 : 1,
      mainColorId: values?.mainColor?.id,
      secondaryColorId: values?.secondaryColor?.id,
      idCreatorTag: values?.artTag?.id,
      publicationDate: values?.publicationDate,
      id: id,
      mainColor: values?.mainColor?.id,
      secondaryColor: values?.secondaryColor?.id,
      ...(values?.categoryId && values?.categoryId !== 0
        ? { categoryId: values?.categoryId }
        : {}),
    };

    const response = await editArt(params, id);
    if (response?.data?.code === 200) {
      navigate(`${pathRoute.website.artroomDetail}/${id}`, {
        state: { isWebsite: true, userId: webProfileData?.id },
      });
    }
  };

  const createFeed = async (values: FormValues) => {
    const formData = new FormData();

    if (values?.description || allImage?.length > 0) {
      formData.append("type", values.type.toString());
      formData.append("text", (values.description || "").trim());

      // Check if we have video or images
      const isVideo = allImage.some((img) => img.file.type.startsWith("video"));

      if (isVideo) {
        formData.append("artVideo", allImage[0].file);
      } else {
        allImage.forEach((img, index) => {
          formData.append("images", img.file);
        });
      }

      dispatch(showLoader());
      try {
        const response = isVideo
          ? await createPostVideo(formData)
          : await createPost(formData);

        if (response?.data?.code === 201) {
          navigate(pathRoute.auth.social, { state: { showDelay: true } });
        }
      } catch (error: any) {
        // Extract message key safely
        const messageKey =
          error?.response?.data?.message_key || // axios-style error
          error?.data?.message_key || // fetch-style error
          error?.message_key;

        const translatedMessage = LanguageTranslation({
          labelName: messageKey || "",
          languageCode: langId || "fr",
        });

        dispatch(
          ToastShow({
            message: translatedMessage || error?.data?.message,
            type: "error",
          })
        );
      } finally {
        dispatch(hideLoader());
      }
    }
  };

  const formatDimensionString = (value: string): string => {
    return value.replace(",", ".");
  };

  const createArrayTypeNode = async (values: FormValues) => {
    const formData = new FormData();

    if (values?.type == 1) {
      const art = {
        height: values?.height,
        width: values?.width,
        depth: values?.depth,
        weight: values?.weight,
        creator: "test",
        creationYear: "2024",
        status: ProductStatus.OnSale,
        title: values?.title,
        framed: isFramed,
        categoryId: values?.categoryId,
        mainColorId: values?.mainColor?.id,
        secondaryColorId: values?.secondaryColor?.id,
        tags: JSON.stringify([values?.artTag?.name]),
        quantity: values?.quantity,
        price: values?.price
          ? +formatDimensionString(values?.price.toString())
          : 0,
        mediaType: isMedia,
        description: values?.description,
        artType: -1,
      };

      formData.append("type", values?.type.toString());
      formData.append("title", values?.title);
      formData.append("art", JSON.stringify(art));

      let hasVideo = false;

      allImage.forEach((item) => {
        if (item.file.type.includes("video")) {
          formData.append("artVideo", item.file);
          hasVideo = true;
        } else {
          formData.append("images", item.file);
        }
      });

      dispatch(showLoader());
      try {
        let response;

        // Use video API if any video is uploaded
        if (hasVideo) {
          response = await createArtroomPostVideo(formData);
        } else {
          response = await createArtroomPost(formData);
        }

        if (response?.data?.code === 201) {
          navigate(pathRoute.auth.social);
        }
      } catch (error: any) {
        // Extract message key safely
        const messageKey =
          error?.response?.data?.message_key || // axios-style error
          error?.data?.message_key || // fetch-style error
          error?.message_key;

        const translatedMessage = LanguageTranslation({
          labelName: messageKey || "",
          languageCode: langId || "fr",
        });

        dispatch(
          ToastShow({
            message: translatedMessage || error?.data?.message,
            type: "error",
          })
        );
      } finally {
        dispatch(hideLoader());
      }
    }
  };

  const onSubmit = async (values: FormValues) => {
    if (
      values.type === 1 &&
      (!values.selectedColors || values.selectedColors.length === 0)
    ) {
      return; // Prevent submission
    }
    if (values.type === 1) {
      const hasExistingMedia = id && (values.profileImage || values.video);
      const hasNewMedia = allImage.length > 0;

      if (!hasExistingMedia && !hasNewMedia) {
        Swal.fire({
          icon: "error",
          title:
            LanguageTranslation({
              labelName: "web_upload_required_title",
              languageCode: langId || "fr",
            }) || "Oops...",
          html:
            LanguageTranslation({
              labelName: "web_upload_required_message",
              languageCode: langId || "fr",
            }) || "Please upload an image or video for your artwork.",
          background: "#fefefe",
          confirmButtonColor: "#3085d6",
          confirmButtonText:
            LanguageTranslation({
              labelName: "ok",
              languageCode: langId || "fr",
            }) || "OK",
          showClass: {
            popup: "animate__animated animate__fadeInDown",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp",
          },
        });
        return;
      }
    }

    if (id) {
      handleEdit(values);
    } else {
      // this for feed post
      if (values?.type === 0) {
        createFeed(values);
      } else {
        // this is for artroom
        createArrayTypeNode(values);
      }
    }
  };

  const handleClose = () => {
    setModalOpen(!modalOpen);
  };
  const handleGuideClose = () => {
    setGuideModal(!guideModal);
  };
  const handleColorPickerClose = () => {
    setColorPickerModal(!colorPickerModal);
  };

  const debouncedSearch = useCallback(
    debounce((data: string) => {
      setSearch(data);
    }, 500), // Delay of 500ms (adjust as necessary)
    []
  );

  const onSearchChange = (data: string) => {
    debouncedSearch(data); // Call the debounced function
  };

  // 1. Update handleFeedupload Function
  // Update handleFeedupload Function
  const handleFeedupload = (
    allowedImageTypes: string[],
    allowedVideoType: string,
    setFieldValue: any,
    selectedFiles: FileList
  ) => {
    const files = Array.from(selectedFiles);
    const videoFile = files.find((file) => file.type === allowedVideoType);

    if (videoFile) {
      if (files.length > 1) {
        Swal.fire({
          icon: "error",
          title:
            LanguageTranslation({
              labelName: "web_upload_required_title",
              languageCode: langId || "fr",
            }) || "Oops...",
          html:
            LanguageTranslation({
              labelName: "web_upload_limit_message",
              languageCode: langId || "fr",
            }) || "You can only upload 1 video or up to 5 images.",
          confirmButtonText:
            LanguageTranslation({
              labelName: "ok",
              languageCode: langId || "fr",
            }) || "OK",
          confirmButtonColor: "#3085d6",
          background: "#fefefe",
        });

        return;
      }

      setAllImages([
        { file: videoFile, photos: URL.createObjectURL(videoFile) },
      ]);
      setIsFileType("video");
      setIsMedia(0); // Set isMedia to 0 for video
    } else {
      if (files.length > 5) {
        Swal.fire({
          icon: "error",
          title:
            LanguageTranslation({
              labelName: "web_upload_required_title",
              languageCode: langId || "fr",
            }) || "Oops...",
          html:
            LanguageTranslation({
              labelName: "web_upload_max_five_limit_message",
              languageCode: langId || "fr",
            }) || "Maximum 5 images allowed",
          background: "#fefefe", // subtle background
          confirmButtonColor: "#3085d6", // nicer button color
          confirmButtonText:
            LanguageTranslation({
              labelName: "ok",
              languageCode: langId || "fr",
            }) || "OK",
          showClass: {
            popup: "animate__animated animate__fadeInDown",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp",
          },
        });
        return;
      }

      const invalidFiles = files.filter(
        (file) => !allowedImageTypes.includes(file.type)
      );
      if (invalidFiles.length > 0) {
        Swal.fire({
          icon: "error",
          title:
            LanguageTranslation({
              labelName: "web_invalid_image_type_title",
              languageCode: langId || "fr",
            }) || "Invalid file type",
          html:
            LanguageTranslation({
              labelName: "web_invalid_image_type_message",
              languageCode: langId || "fr",
            }) || "Only JPG or PNG images are allowed.",
          background: "#fefefe",
          confirmButtonColor: "#3085d6",
          confirmButtonText:
            LanguageTranslation({
              labelName: "ok",
              languageCode: langId || "fr",
            }) || "OK",
          showClass: {
            popup: "animate__animated animate__fadeInDown",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp",
          },
        });

        return;
      }

      const updatedPhotos = files.map((file) => ({
        file,
        photos: URL.createObjectURL(file),
      }));

      setAllImages(updatedPhotos);
      setIsFileType("image");
      setIsMedia(1); // Set isMedia to 1 for images
    }
  };

  // Update handleArtupload Function
  const handleArtupload = (
    allowedImageTypes: string[],
    allowedVideoType: string,
    setFieldValue: any,
    selectedFiles: FileList
  ) => {
    const files = Array.from(selectedFiles);
    if (files.length > 1) {
      Swal.fire({
        icon: "error",
        title:
          LanguageTranslation({
            labelName: "web_upload_required_title",
            languageCode: langId || "fr",
          }) || "Oops...",
        html:
          LanguageTranslation({
            labelName: "web_only_one_file_message",
            languageCode: langId || "fr",
          }) || "You can only upload 1 file. Please remove extra files.",
        background: "#fefefe",
        confirmButtonColor: "#3085d6",
        confirmButtonText:
          LanguageTranslation({
            labelName: "ok",
            languageCode: langId || "fr",
          }) || "OK",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      });

      return;
    }

    const file = files[0];
    const isVideo = file.type === allowedVideoType;

    if (isVideo) {
      setAllImages([{ file, photos: URL.createObjectURL(file) }]);
      setIsMedia(0); // 0 for video
      setIsFileType("video");
    } else if (allowedImageTypes.includes(file.type)) {
      setAllImages([{ file, photos: URL.createObjectURL(file) }]);
      setIsMedia(1); // 1 for image
      setIsFileType("image");
    } else {
      Swal.fire({
        icon: "error",
        title:
          LanguageTranslation({
            labelName: "web_invalid_image_type_title",
            languageCode: langId || "fr",
          }) || "Invalid file type",

        confirmButtonColor: "#3085d6",
        confirmButtonText:
          LanguageTranslation({
            labelName: "ok",
            languageCode: langId || "fr",
          }) || "OK",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      });
    }
  };
  const handleImageUpload = (
    e: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: any,
    values: any
  ) => {
    const selectedFiles = e.target.files;
    if (!selectedFiles) return;

    const allowedImageTypes = ["image/jpeg", "image/png"];
    const allowedVideoType = "video/mp4";

    if (values?.type == 0) {
      handleFeedupload(
        allowedImageTypes,
        allowedVideoType,
        setFieldValue,
        selectedFiles
      );
    } else {
      handleArtupload(
        allowedImageTypes,
        allowedVideoType,

        setFieldValue,
        selectedFiles
      );
    }
  };

  // 1. Update handleRemoveImage function
  const handleRemoveImage = (index: number) => {
    setAllImages((prev) => {
      const newImages = [...prev];
      newImages.splice(index, 1);
      return newImages;
    });

    // Reset file input field
    const fileInput = document.getElementById(
      "upload-file"
    ) as HTMLInputElement;
    if (fileInput) {
      fileInput.value = ""; // Clear the input value
    }

    // Reset related states
    setIsFileType("");
    setIsMedia(0);
  };
  return (
    <>
      <div className="xl:py-6 py-4 xl:px-10 lg:px-6 md:px-4 px-3 ">
        <Paragraph text24 className="md:mb-6 sm:mb-5 mb-4">
          {id
            ? LanguageTranslation({
                labelName: "edit_post_new",
                languageCode: langId || "fr",
              }) || "Edit Post"
            : LanguageTranslation({
                labelName: "create_new_post",
                languageCode: langId || "fr",
              }) || "Create New Post"}
        </Paragraph>
        <div className="border border-medium-grey rounded-2xl overflow-hidden">
          <Formik
            key={langId}
            initialValues={defaultInitialValues}
            onSubmit={onSubmit}
            enableReinitialize={!!id} // Only enable for edits
            validationSchema={isFeed == 1 && postValidationSchemaLang}
            innerRef={formikRef} // Attach the ref to Formik
            validateOnChange={false}
          >
            {({
              isSubmitting,
              values,
              setFieldValue,
              touched,
              errors,
              setErrors,
              setFieldTouched,
            }) => (
              <Form>
                <div className="grid grid-cols-12">
                  <div className="xxl:col-span-3 sm:col-span-4 col-span-12 bg-light-grey xl:p-30 md:p-5 p-3">
                    <FormLabel>
                      {" "}
                      {LanguageTranslation({
                        labelName: "upload_image_video",
                        languageCode: langId || "fr",
                      }) || "Upload image/video"}
                    </FormLabel>
                    <label
                      htmlFor="upload-file"
                      className="px-4 py-3.5 md:h-[180px] h-[120px] bg-white rounded-lg border border-dashed border-medium-grey flex flex-col justify-center items-center gap-3 cursor-pointer"
                    >
                      {!id && (
                        <input
                          type="file"
                          name="profileImage"
                          id="upload-file"
                          multiple
                          className="sr-only"
                          accept="image/*,video/*"
                          onChange={(e) =>
                            handleImageUpload(e, setFieldValue, values)
                          }
                        />
                      )}

                      {allImage.length > 0 ? (
                        allImage[0]?.file?.type?.includes("video") ? (
                          <div className="block rounded-[20px] overflow-hidden relative w-full h-full">
                            <VideoPreview
                              src={allImage[0].photos} // Use stored URL
                              className="h-full w-full object-cover rounded-[20px]"
                              onRemove={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                handleRemoveImage(0);
                              }}
                            />
                            <span
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                handleRemoveImage(0);
                              }}
                              className="absolute top-2 right-2 w-6 h-6 bg-white text-black rounded-full flex items-center justify-center shadow-md z-10 cursor-pointer"
                            >
                              <IoClose size={16} />
                            </span>
                          </div>
                        ) : (
                          <div className="relative w-full h-full">
                            <img
                              src={URL.createObjectURL(allImage[0].file)}
                              alt="main-preview"
                              className="w-full h-full object-cover rounded-[20px]"
                            />
                            <span
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                handleRemoveImage(0);
                              }}
                              className="absolute top-2 right-2 w-6 h-6 bg-white text-black rounded-full flex items-center justify-center shadow-md z-10 cursor-pointer"
                            >
                              <IoClose size={16} />
                            </span>
                          </div>
                        )
                      ) : id && (values.video || values.profileImage) ? (
                        values.video ? (
                          <div className="block rounded-[20px] overflow-hidden relative w-full h-full">
                            <video
                              className="h-full w-full object-cover rounded-[20px]"
                              src={values.video} // Directly use values.video as it is a string URL
                              controls
                            />
                            {!id && (
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  setFieldValue("video", "");
                                  setFieldValue("profileImage", "");
                                  setAllImages([]);
                                }}
                                className="absolute top-2 right-2 w-6 h-6 bg-white text-black rounded-full flex items-center justify-center shadow-md z-10 cursor-pointer"
                              >
                                <IoClose size={16} />
                              </span>
                            )}
                          </div>
                        ) : (
                          <div className="relative w-full h-full">
                            <img
                              src={values.profileImage}
                              alt="existing-preview"
                              className="w-full h-full object-cover rounded-[20px]"
                            />
                            {!id && (
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  setFieldValue("profileImage", "");
                                  setFieldValue("video", "");
                                  setAllImages([]);
                                }}
                                className="absolute top-2 right-2 w-6 h-6 bg-white text-black rounded-full flex items-center justify-center shadow-md z-10 cursor-pointer"
                              >
                                <IoClose size={16} />
                              </span>
                            )}
                          </div>
                        )
                      ) : (
                        <div>
                          <img
                            src={UploadFile}
                            alt="upload-file"
                            width={30}
                            height={30}
                            className="mx-auto"
                          />
                          <Paragraph
                            text12
                            className="!text-dark-grey mt-2 text-center"
                          >
                            {LanguageTranslation({
                              labelName: "web_upload_file",
                              languageCode: langId || "fr",
                            }) || "Upload file"}
                          </Paragraph>
                        </div>
                      )}
                    </label>

                    {/* Additional images grid */}
                    {values?.type === 0 && allImage.length > 1 && (
                      <div className="flex flex-wrap items-stretch gap-3 mt-4">
                        {allImage.slice(1).map((item: Photo, index: number) => (
                          <div
                            key={index + 1}
                            className="relative sm:w-[calc(50%-6px)] w-[calc(25%-9px)]"
                          >
                            <img
                              src={URL.createObjectURL(item.file)}
                              alt={`preview-${index + 1}`}
                              className="object-cover rounded-[4px] aspect-[4/3]"
                            />
                            <span
                              onClick={() => handleRemoveImage(index + 1)}
                              className="absolute -top-1.5 -right-1.5 sm:w-6 sm:h-6 w-5 h-5 flex items-center justify-center rounded-full bg-gradient-to-r from-site-black -from-[6.79%] to-site-black/0 to-[155.78%] backdrop-blur-md text-white cursor-pointer"
                            >
                              <IoClose />
                            </span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="xxl:col-span-9 sm:col-span-8 col-span-12 xl:p-30 md:p-5 p-3">
                    <div className="grid grid-cols-12 lg:gap-6 md:gap-5 gap-3">
                      <div className="col-span-12">
                        <FormLabel>
                          {" "}
                          {LanguageTranslation({
                            labelName: "description",
                            languageCode: langId || "fr",
                          }) || "Description"}
                        </FormLabel>
                        <TextArea
                          name="description"
                          rows={5}
                          placeholder={
                            LanguageTranslation({
                              labelName: "what_do_you_want_to_share",
                              languageCode: langId || "fr",
                            }) || "What do you want to share?"
                          }
                          // value={values.description}
                        />
                      </div>
                      {!id && (
                        <>
                          <div className="col-span-12">
                            <Paragraph text16 className="mb-3">
                              {LanguageTranslation({
                                labelName:
                                  "would_you_like_to_sell_your_product?",
                                languageCode: langId || "fr",
                              }) || "Would you like to sell your product?"}
                            </Paragraph>
                            <div className="flex items-center gap-[30px]">
                              <RadioButton
                                id="1"
                                name="type"
                                labelClass="!text-base"
                                onChange={() => {
                                  if (webProfileData?.hasAccount) {
                                    setFieldValue("type", 1);
                                    setIsFeed(1);
                                  } else {
                                    setGuideModal(true);
                                  }
                                }}
                                // checked={values?.type == 1 ? true : false}
                                checked={values?.type === 1}
                              >
                                {LanguageTranslation({
                                  labelName: "yes",
                                  languageCode: langId || "fr",
                                }) ?? "Yes"}
                              </RadioButton>
                              <RadioButton
                                id="0"
                                name="type"
                                labelClass="!text-base"
                                onChange={() => {
                                  setFieldValue("type", 0);
                                  setIsFeed(0);
                                }}
                                // checked={values?.type == 0 ? true : false}
                                checked={values?.type === 0}
                              >
                                {LanguageTranslation({
                                  labelName: "no",
                                  languageCode: langId || "fr",
                                }) ?? "No"}
                              </RadioButton>
                            </div>
                          </div>
                          {values?.type == 1 && (
                            <div className="col-span-12">
                              <div className="flex items-center gap-[30px]">
                                <Paragraph text16>
                                  {" "}
                                  {LanguageTranslation({
                                    labelName: "framed_artwork",
                                    languageCode: langId || "fr",
                                  }) || "Framed artwork"}
                                </Paragraph>
                                <SwitchToggle
                                  langId={langId}
                                  onChange={(value) => setIsFramed(value)}
                                  isChecked={isFramed}
                                />
                              </div>
                            </div>
                          )}
                        </>
                      )}

                      {values?.type == 1 && (
                        <>
                          <div className="xl:col-span-4 lg:col-span-6  sm:col-span-6 col-span-12">
                            <FormLabel>
                              {LanguageTranslation({
                                labelName: "title",
                                languageCode: langId || "fr",
                              }) || "Title"}
                              <span className="text-site-red">*</span>
                            </FormLabel>
                            <InputType
                              name="title"
                              type="text"
                              value={values.title}
                              placeholder={
                                LanguageTranslation({
                                  labelName: "web_enter_title",
                                  languageCode: langId || "fr",
                                }) || "Enter title"
                              }
                            />
                          </div>
                          <div className="xl:col-span-4 lg:col-span-6  sm:col-span-6 col-span-12">
                            <FormLabel>
                              {LanguageTranslation({
                                labelName: "height",
                                languageCode: langId || "fr",
                              }) || "Height"}
                              <span className="text-site-red">*</span>{" "}
                              <span className="text-[#a0a0a0]">(cm)</span>
                            </FormLabel>
                            <InputType
                              name="height"
                              type="number"
                              placeholder={
                                LanguageTranslation({
                                  labelName: "enter_height",
                                  languageCode: langId || "fr",
                                }) || "Enter height"
                              }
                              value={values.height}
                            />
                          </div>
                          <div className="xl:col-span-4 lg:col-span-6  sm:col-span-6 col-span-12">
                            <FormLabel>
                              {LanguageTranslation({
                                labelName: "width",
                                languageCode: langId || "fr",
                              }) || "Width"}{" "}
                              <span className="text-site-red">*</span>{" "}
                              <span className="text-[#a0a0a0]">(cm)</span>
                            </FormLabel>
                            <InputType
                              name="width"
                              type="number"
                              placeholder={
                                LanguageTranslation({
                                  labelName: "web_enter_width",
                                  languageCode: langId || "fr",
                                }) || "Enter width"
                              }
                              value={values.width}
                            />
                          </div>
                          <div className="xl:col-span-4 lg:col-span-6  sm:col-span-6 col-span-12">
                            <FormLabel>
                              {LanguageTranslation({
                                labelName: "weight",
                                languageCode: langId || "fr",
                              }) || "Weight"}{" "}
                              <span className="text-site-red">*</span>{" "}
                              <span className="text-[#a0a0a0]">(kg)</span>
                            </FormLabel>
                            <InputType
                              name="weight"
                              type="number"
                              placeholder={
                                LanguageTranslation({
                                  labelName: "enter_weight",
                                  languageCode: langId || "fr",
                                }) || "Enter weight"
                              }
                              value={values.weight}
                            />
                          </div>
                          <div className="xl:col-span-4 lg:col-span-6  sm:col-span-6 col-span-12">
                            <FormLabel>
                              {LanguageTranslation({
                                labelName: "depth",
                                languageCode: langId || "fr",
                              }) || "Depth"}{" "}
                              <span className="text-site-red">*</span>{" "}
                              <span className="text-[#a0a0a0]">(cm)</span>
                            </FormLabel>
                            <InputType
                              name="depth"
                              type="number"
                              placeholder={
                                LanguageTranslation({
                                  labelName: "enter_depth",
                                  languageCode: langId || "fr",
                                }) || "Enter depth"
                              }
                              value={values.depth}
                            />
                          </div>
                          <div className="xl:col-span-4 lg:col-span-6  sm:col-span-6 col-span-12">
                            <FormLabel>
                              {LanguageTranslation({
                                labelName: "price",
                                languageCode: langId || "fr",
                              }) || "Price"}
                              <span className="text-site-red">*</span>
                            </FormLabel>
                            <InputType
                              name="price"
                              type="number"
                              placeholder={
                                LanguageTranslation({
                                  labelName: "enter_price",
                                  languageCode: langId || "fr",
                                }) || "Enter price"
                              }
                              value={values.price}
                              disabled={id ? true : false}
                            />
                          </div>
                          <div className="xl:col-span-4 lg:col-span-6 sm:col-span-6 col-span-12">
                            <FormLabel>
                              {LanguageTranslation({
                                labelName: "exemplar",
                                languageCode: langId || "fr",
                              }) || "Exemplar"}{" "}
                              <span className="text-site-red">*</span>
                            </FormLabel>
                            <InputType
                              name="quantity"
                              type="number"
                              placeholder={
                                LanguageTranslation({
                                  labelName: "enter_quantity",
                                  languageCode: langId || "fr",
                                }) || "Enter quantity"
                              }
                              disabled={id ? true : false}
                              value={values.quantity}
                            />
                          </div>
                          <div className="xl:col-span-4 lg:col-span-6 sm:col-span-6 col-span-12">
                            <FormLabel>
                              {LanguageTranslation({
                                labelName: "category",
                                languageCode: langId || "fr",
                              }) || "Category"}{" "}
                              <span className="text-site-red">*</span>
                            </FormLabel>
                            <SelectType
                              langId={langId}
                              options={categoryOptions}
                              placeholder={
                                LanguageTranslation({
                                  labelName: "select_category",
                                  languageCode: langId || "fr",
                                }) || "Select category"
                              }
                              fullWidth
                              onChange={(selectedOption: {
                                value: string;
                                label: string;
                              }) => {
                                setFieldValue(
                                  "category",
                                  selectedOption?.label
                                );
                                setFieldValue(
                                  "categoryId",
                                  selectedOption?.value
                                );
                                setErrors({
                                  category: "",
                                });
                              }}
                              value={
                                categoryOptions?.find(
                                  (option: any) =>
                                    option?.label === values.category
                                ) || ""
                              }
                            />
                            {touched.category && errors?.category && (
                              <div className="text-site-red text-sm font-medium mb-2">
                                {errors.category}
                              </div>
                            )}
                          </div>
                          <div className="xl:col-span-4 lg:col-span-6 sm:col-span-6 col-span-12">
                            <FormLabel>
                              {LanguageTranslation({
                                labelName: "artag",
                                languageCode: langId || "fr",
                              }) || "Artag"}{" "}
                            </FormLabel>
                            {values?.type == 1 && (
                              <SelectType
                                langId={langId}
                                loading={loading}
                                placeholder={
                                  LanguageTranslation({
                                    labelName: "select_tag",
                                    languageCode: langId || "fr",
                                  }) || "Select tag"
                                }
                                onChange={(selectedOption: {
                                  value: string;
                                  label: string;
                                }) => {
                                  setFieldValue("artTag", {
                                    id: selectedOption?.value,
                                    name: selectedOption?.label,
                                  });
                                }}
                                options={artOptions}
                                fullWidth
                                isSearchable={true}
                                onSearchChange={onSearchChange}
                                value={
                                  values?.artTag?.id
                                    ? {
                                        value: values?.artTag?.id,
                                        label: values?.artTag?.name,
                                      }
                                    : null
                                }
                                getNextPage={getNextPage} // Pass getNextPage to SelectType
                                hasMore={hasMore} // Pass hasMore to SelectType
                              />
                            )}
                            {touched?.artTag?.name && (
                              <div className="text-site-red text-sm font-medium mb-2">
                                {errors?.artTag?.name}
                              </div>
                            )}
                          </div>

                          <div className="sm:col-span-6 col-span-12">
                            <FormLabel>
                              {" "}
                              {LanguageTranslation({
                                labelName: "colourimetry",
                                languageCode: langId || "fr",
                              }) || "Colourimetry"}{" "}
                            </FormLabel>
                            <div className="flex align-items-center gap-2.5">
                              <span
                                onClick={() => setColorPickerModal(true)}
                                className="flex items-center justify-center rounded-full bg-site-black w-10 h-10 cursor-pointer"
                              >
                                <img
                                  src={ColorWheel}
                                  alt="color-wheel"
                                  width={26}
                                  height={26}
                                />
                              </span>
                              {values?.secondaryColor?.hexcode && (
                                <span
                                  className="flex items-center justify-center rounded-full w-10 h-10 cursor-pointer border border-medium-grey"
                                  style={{
                                    background: `${values?.secondaryColor?.hexcode}`,
                                  }}
                                ></span>
                              )}
                              {values?.mainColor?.hexcode && (
                                <span
                                  className="flex items-center justify-center rounded-full w-10 h-10 cursor-pointer border border-medium-grey"
                                  style={{
                                    background: `${values?.mainColor?.hexcode}`,
                                  }}
                                ></span>
                              )}
                            </div>

                            {/* Show error message only after submit or touch */}
                            {touched.mainColor &&
                              touched.secondaryColor &&
                              !values?.mainColor?.hexcode &&
                              !values?.secondaryColor?.hexcode && (
                                <div className="text-site-red text-sm font-medium mb-2">
                                  {LanguageTranslation({
                                    labelName: "web_color_required",
                                    languageCode: langId,
                                  }) || "Color is required"}
                                </div>
                              )}
                          </div>
                        </>
                      )}
                      <div className="col-span-12 mt-1.5">
                        <div className="flex items-center xl:justify-end justify-start gap-4">
                          <Button
                            type="button"
                            borderButton
                            className="lg:w-auto w-full"
                            onClick={() => {
                              // Reset Formik form to initial values
                              if (formikRef.current) {
                                formikRef.current.resetForm({
                                  values: defaultInitialValues, // Reset to initial values
                                });
                              }

                              // Reset component states
                              setAllImages([]); // Clear uploaded images/videos
                              setIsFramed(false); // Reset framed toggle
                              setIsMedia(0); // Reset media type
                              setIsFileType(""); // Reset file type
                              setIsFeed(0); // Reset feed type
                              setArtOptions([]); // Clear art tag options
                              setSearch(""); // Clear search term
                              setHasMore(true); // Reset pagination
                              pageRef.current = 1; // Reset page reference
                            }}
                          >
                            {LanguageTranslation({
                              labelName: "cancel",
                              languageCode: langId || "fr",
                            }) || "Cancel"}
                          </Button>
                          {id ? (
                            <Button
                              primary
                              type="submit"
                              className="lg:w-auto w-full"
                            >
                              {LanguageTranslation({
                                labelName: "edit",
                                languageCode: langId || "fr",
                              }) || "Edit"}
                            </Button>
                          ) : (
                            <Button
                              primary
                              type="submit"
                              className="lg:w-auto w-full"
                              disabled={
                                values?.type == 0 &&
                                (!values?.description ||
                                  values?.description.trim() === "") &&
                                allImage?.length === 0
                              }
                            >
                              {LanguageTranslation({
                                labelName: "post",
                                languageCode: langId || "fr",
                              }) || "Post"}
                            </Button>
                          )}
                        </div>
                        {/* <Button
                          onClick={() => setGuideModal(true)}
                          primary
                          className="min-w-[240px] sm:w-auto w-full"
                        >
                          Save
                        </Button> */}
                        <Modal
                          open={guideModal}
                          onClose={handleGuideClose}
                          header
                          width="w-[650px] lg:h-[450px] sm:h-[380px] h-auto"
                          closeOnBackdropClick={false}
                        >
                          <GuideModal
                            open={guideModal}
                            onClose={handleGuideClose}
                          />
                        </Modal>
                        <Modal
                          open={colorPickerModal}
                          onClose={handleColorPickerClose}
                          header
                        >
                          <ColorPickerModal
                            open={colorPickerModal}
                            onClose={handleColorPickerClose}
                            colorOptions={colorOptions}
                            selectedColors={values?.selectedColors || []}
                            id={id}
                            langId={langId}
                          />
                        </Modal>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      {lightboxOpen && (
        <div className={"lightbox-no-navigation"}>
          <Lightbox
            open={lightboxOpen}
            close={closeLightbox}
            slides={[
              {
                type: "video",
                sources: [{ src: videoUrl || "", type: "video/mp4" }],
              },
            ]}
            plugins={[Video]}
            carousel={{
              finite: true,
              padding: 0,
            }}
            video={{
              autoPlay: true,
              controls: true,
              playsInline: true,
              loop: false,
            }}
          />
        </div>
      )}
    </>
  );
}

export default CreatePost;
